export function getRobuxWithRate(value, rate) {
  return +(value / rate).toFixed(2)
}
